import { ExamReassignmentQCTaskPreview } from '@common/config/api/client'
import { East } from '@mui/icons-material'
import { Chip, Stack, TableBody, TableCell, TableRow, Typography, useTheme } from '@mui/material'

export default function ReassignExamTaskQCTableBody({ tasks }: { tasks: ExamReassignmentQCTaskPreview[] }) {
  const theme = useTheme()
  const formatDate = (date: string) => {
    return new Date(date).toLocaleDateString('en-GB')
  }

  const formatStatus = (status: string) => {
    return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase().replace(/_/g, ' ')
  }

  return (
    <TableBody>
      {tasks.map((task, index) => {
        const isLast = index === tasks.length - 1
        const isNew = task.task_id === 'new'
        return (
          <TableRow key={index}>
            <TableCell
              sx={{
                borderBottom: isLast ? 'none' : `1px solid ${theme.palette.secondary.main}`,
              }}
            >
              <Stack>
                <Typography color="text.primary" variant="body2">
                  {isNew ? 'QC 1' : task.task_name}
                </Typography>
                <Typography color="text.secondary" variant="caption">
                  {isNew ? 'New task will be created' : formatDate(task.create_date || '')}
                </Typography>
              </Stack>
            </TableCell>
            <TableCell
              sx={{
                borderBottom: isLast ? 'none' : `1px solid ${theme.palette.secondary.main}`,
              }}
            >
              {!isNew && (
                <Typography color="text.primary" variant="body2">
                  {formatStatus(task.from_status)}
                </Typography>
              )}
            </TableCell>
            <TableCell
              sx={{
                borderBottom: isLast ? 'none' : `1px solid ${theme.palette.secondary.main}`,
              }}
            >
              {!isNew && (
                <Stack>
                  <East />
                </Stack>
              )}
            </TableCell>
            <TableCell
              sx={{
                borderBottom: isLast ? 'none' : `1px solid ${theme.palette.secondary.main}`,
              }}
            >
              {isNew ? (
                <Chip
                  label="New task"
                  size="small"
                  sx={{
                    bgcolor: '#C9E8F2',
                  }}
                />
              ) : (
                <Typography color="text.primary" variant="body2">
                  {task.to_status ? formatStatus(task.to_status) : '—'}
                </Typography>
              )}
            </TableCell>
          </TableRow>
        )
      })}
    </TableBody>
  )
}
